import { MatchingPropertiesContext } from "context/MatchingPropertiesContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useMatchingProperties = () => {
  return useProviderInitializedContext(MatchingPropertiesContext);
};
